module.exports = __webpack_public_path__ + "img/site.dd9ac76a.png";